import React, { useEffect, useState } from 'react'
import delet from '../../../Assets/Images/delete.svg';
import edit from '../../../Assets/Images/edit.svg';
import Popup from 'reactjs-popup';
import { Link, useParams } from 'react-router-dom';
import { ToastContainer } from 'react-toastify';
import LoadingOverlay from '../../LoadingOverlay/LoadingOverlay';
import { useContact } from '../../../Context/ContactUsContext';

function AllContactsTable() {
  const { getContact, isContact } = useContact();
  const { lang } = useParams();

  useEffect(() => {
    getContact(lang);
  }, []);

  return (
    <div className='bg-[#fff] rounded-2xl p-3'>
      {!isContact && <LoadingOverlay />} {/* Display loading overlay */}
      <table className='w-full border-collapse mb-6'>
        <thead>
          <tr className='p-2'>
            <th className='text-[16px] font-[500] text-[#0966AE] font-[Cairo] py-2 px-5 text-start' style={{ width: '30%' }}>SN</th>
            <th className='text-[16px] font-[500] text-[#0966AE] font-[Cairo] py-2 px-5 text-start' style={{ width: '40%' }}>Name</th>
            <th className='text-[16px] font-[500] text-[#0966AE] font-[Cairo] py-2 px-5 text-start' style={{ width: '40%' }}>Action</th>
          </tr>
        </thead>
        <tbody>
          {isContact?.data?.map((Contacts, index) => (
            <tr key={index}>
              <td className='p-5 text-start' style={{ width: '30%' }}>{String(index + 1).padStart(2, '0') + "."}</td>
              <td className='p-5 text-start' style={{ width: '40%' }}>{Contacts.name}</td>
              <td className='p-5 text-center' style={{ width: '40%' }}>
                <div className='flex gap-2 items-center'>
                  <Link to={`/Contacts/EditContact/${Contacts.id}`}>
                    <img src={edit} alt="" className='bg-[#148342] p-2 w-[40px] cursor-pointer rounded-md border' />
                  </Link>
                </div>
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
}

export default AllContactsTable